import { FIELD_CONFIG } from '../_helpers/field-config'

interface ConfirmationHeaderProps {
  checkedCount: number
}

export const ConfirmationHeader = ({ checkedCount }: ConfirmationHeaderProps) => {
  const totalCount = FIELD_CONFIG.length
  const progressPct = (checkedCount / totalCount) * 100

  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div>
        <h2 className="text-lg font-bold tracking-tight">Confirmação de dados</h2>
        <p className="text-sm text-brand-grayscale-7">
          Compare os dados informados pelo paciente com os dados oficiais e confirme cada campo.
        </p>
      </div>

      <div className="flex w-full min-w-[220px] max-w-sm flex-col gap-1.5">
        <div className="flex items-baseline justify-between text-[10px] uppercase tracking-[0.18em] text-brand-grayscale-6">
          <span>Progresso</span>
          <span className="tabular-nums text-brand-grayscale-9">
            {checkedCount}/{totalCount}
          </span>
        </div>
        <div className="h-1 w-full overflow-hidden bg-brand-grayscale-3">
          <div
            className="h-full bg-brand-green-primary-5 transition-[width] duration-300"
            style={{ width: `${progressPct}%` }}
          />
        </div>
      </div>
    </div>
  )
}
